import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function ItemsLeftAtHome({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <p>
              If the tenant has left/abandoned any items at the home follow this
              process.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -any items of no value can be disposed of, this would be old food,
              clothes, damaged furniture and trash
            </p>
          </Col>
          <Col span={24}>
            <p>
              -if anything of value is left send this letter right away and
              notify the make ready crew if you have not already. The{" "}
              <span className="onclick-text">letter</span> must be mailed
              certified mail and sent to their forwarding address or the house
              if no forwarding address was given.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -items of value must be stored for up to 30 days and can be moved
              into the garage or another area of the property while work is
              being done.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -the tenant must set up an appointment with a handyman to meet and
              get their belonging. then add the fee of the handyman to the
              tenants ledger for collections.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -if items are stored also add a charge for each day stored equal
              to the daily rental rate for the unit so that the owner can bill
              the tenant for this.
            </p>
          </Col>
          <Col span={24}>
            <p>-the-if confused on any item please contact the broker</p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default ItemsLeftAtHome;
